import store from '@/store'
import { format } from 'date-fns'

export const beforeAppRouteInit = async (to, from, next) => {
  if (
    !to.params.district_id &&
    to.name !== 'login' &&
    to.name !== 'sso-callback'
  ) {
    return next('/skane/event')
  }

  if (to.path !== '/login')
    switch (to.params.district_id) {
      case 'skane':
        store.set('app/selectedDistrictId', 4)
        break
      case 'otraf':
        store.set('app/selectedDistrictId', 5)
        break
      case 'tib':
        store.set('app/selectedDistrictId', 17)
        break
      case 'x-trafik':
        store.set('app/selectedDistrictId', 19)
        break
      case 'norrtag':
        store.set('app/selectedDistrictId', 21)
        break
      case 'oresundstag':
        store.set('app/selectedDistrictId', 22)
        break
      default:
        store.set('app/selectedDistrictId', 4)
    }

  if (
    to.name !== 'login' &&
    to.name !== 'sso-callback' &&
    !store.get('app/ready')
  ) {
    const selectedDistrictId = store.get('app/selectedDistrictId')
    if (selectedDistrictId === 21 || selectedDistrictId === 22) {
      await Promise.all([
        store.dispatch('event/fetchStops'),

        store.dispatch('linkDeviation/fetchUnhandledCrewDeviations', {
          district_id: store.get('app/selectedDistrictId')
        }),

        store.dispatch('odoc/fetchPropsalCasesCount'),
        store.dispatch(
          'tibBanner/fetchInital',
          format(new Date(), 'yyyy-MM-dd')
        )
      ])
    } else {
      await Promise.all([
        store.dispatch('event/fetchStops'),
        store.dispatch('linkDeviation/fetchUnhandledDelays', {
          district_id: store.get('app/selectedDistrictId')
        }),
        store.dispatch('linkDeviation/fetchUnhandledCrewDeviations', {
          district_id: store.get('app/selectedDistrictId')
        }),
        store.dispatch('linkDeviation/fetchUnhandledTrainDeviations', {
          district_id: store.get('app/selectedDistrictId')
        }),
        store.dispatch('odoc/fetchPropsalCasesCount'),
        store.dispatch(
          'tibBanner/fetchInital',
          format(new Date(), 'yyyy-MM-dd')
        )
      ])
    }
    store.set('app/ready', true)
  }
}
